//testing backend endpoints
/* export const ENDPOINT = "http://20.163.56.84/api/";
export const AUTHPOINT = "http://20.163.56.84/api/auth/";
export const PROFILEPICTURE = "http://20.163.56.84/Users/Photo/";
 */
//new backend endpoints
export const ENDPOINT = "https://ccms.slcgmel.net/api/";
export const AUTHPOINT = "https://ccms.slcgmel.net/api/auth/";
export const PROFILEPICTURE = "https://ccms.slcgmel.net/Users/Photo/";

/* new backend endpoints for live */
/* export const ENDPOINT = "http://20.25.159.77/api/";
export const AUTHPOINT = "http://20.25.159.77/api/auth/";
export const PROFILEPICTURE = "http://20.25.159.77/Users/Photo/";   */

/* export const ENDPOINT = "http://18.117.87.47/api/";
export const AUTHPOINT = "http://18.117.87.47/api/auth/";
export const PROFILEPICTURE = "http://18.117.87.47/Users/Photo/";   */



export const DOCUMENT_TYPE = ENDPOINT + "document_type";
export const SUB_DOCUMENT_TYPE = ENDPOINT + "sub_document_type";
export const DISABLED_DATE = ENDPOINT + "disabled_date";
export const SUB_DOCUMENT_TYPE_FIELD = ENDPOINT + "sub_document_type_field";
export const APPLICATION = ENDPOINT + "application";
export const APPOINTMENT = ENDPOINT + "appointment";
export const DESIGNATED_TIMESLOT = ENDPOINT + "designated_timeslot";
export const APPOINTMENT_APPLICATION = ENDPOINT + "appointment_application";
export const SUB_DOCUMENT_TYPE_AMOUNT = ENDPOINT + "sub_document_type_amount";
export const STATUS_GROUP_STATUS = ENDPOINT + "status_group_status";
export const LETTER_FORMAT = ENDPOINT + "letter_format";
export const AMOUNT = ENDPOINT + "amount";
export const LOG = ENDPOINT + "log";
export const REPORT_TYPE = ENDPOINT + "report_type";
export const DOCUMENT_TYPE_FIELD = ENDPOINT + "document_type_field";
export const STATUS_FIELD = ENDPOINT + "status_field";
export const STATUS = ENDPOINT + "status";
export const STATUS_GROUP = ENDPOINT + "status_group";
export const USER = ENDPOINT + "user";
export const EMAIL_FORMAT = ENDPOINT + "email_format";
export const DISABLED_SUB_DOCUMENT_TYPE = ENDPOINT + "disabled_sub_document_type";



export const LOGIN_URL = AUTHPOINT + "login";
export const REFRESH = AUTHPOINT + "refresh";
export const USERINFOR_URL = AUTHPOINT + "user-profile";




export const GENERATE_REPORT = ENDPOINT + "reports/all";

export const ALL_USERS = ENDPOINT + "users/all";
export const CREATE_USER = ENDPOINT + "users/create";
export const USER_SET_PASSWORD = ENDPOINT + "email/verify/";
export const USER_RESET_PASSWORD = ENDPOINT + "users/forgotpassword";
export const MY_PROFILE = ENDPOINT + "users/myDetails";
export const GET_SINGLE_USER = ENDPOINT + "user/single/";
export const EDIT_USER = ENDPOINT + "users/edit/";
export const UPLOAD_PROFILE_PICTURE = ENDPOINT + "users/upload/profilepic";
export const USER_ACTIVE_STATUS_CHANGE = ENDPOINT + "users/active/";

export const UPLOAD_FILES = ENDPOINT + "incidents/uploads";
export const UPLOAD_NEW_FILES = ENDPOINT + "incidents/addNewFiles";
export const DELETE_FILES = ENDPOINT + "incidents/file/delete";

export const CREATE_INCIDENT = ENDPOINT + "incidents/create";
export const ALL_CORRUPTIONS = ENDPOINT + "statistics/allcorruptions";
export const ALL_CORRUPTIONS_FOR_MAP = ENDPOINT + "map/allincidents";
export const All_INCIDENT_WITH_FILTERS = ENDPOINT + "incidents/withfilters";
export const All_INCIDENT_WITH_FILTERS_PUBLIC = ENDPOINT + "incidents/published";
export const GET_SINGLE_INCIDENT = ENDPOINT + "incidents/single/";
export const UPDATE_INCIDENT_STATE = ENDPOINT + "incidents/changeStatus/";
export const UPDATE_INCIDENT_PUBLISH = ENDPOINT + "incidents/changePublish/";
export const Edit_INCIDENT = ENDPOINT + "incidents/edit/";

export const ALL_STATISTICS = ENDPOINT + "statistics/allcounts";
export const ALL_STATISTICS_BY_YEARLY = ENDPOINT + "allincidents/yearly";
export const ALL_STATISTICS_BY_GENDER = ENDPOINT + "statistics/count/genderwise";
export const ALL_STATISTICS_BY_AGE = ENDPOINT + "statistics/count/agewise";
export const ALL_STATISTICS_BY_ORGANIZATION = ENDPOINT + "statistics/count/organizationwise";

export const CREATE_NEWS = ENDPOINT + "news/create";
export const GET_NEWS_WITH_FILTERS = ENDPOINT + "news/withfilters";
export const GET_SINGLE_NEWS = ENDPOINT + "news/single/";
export const UPLOAD_NEWS_FILES = ENDPOINT + "news/uploads";
export const UPDATE_NEWS_STATE = ENDPOINT + "news/changeStatus/";
export const UPDATE_NEWS_PUBLISH = ENDPOINT + "news/changePublish/";

export const EDIT_NEWS = ENDPOINT + "news/edit/";
export const UPLOAD_NEWS_NEW_FILES = ENDPOINT + "news/addNewFiles";
export const DELETE_NEWS_FILES = ENDPOINT + "news/file/delete";

export const GET_ELECTION_STATUS = ENDPOINT + "elections/status";
export const CHANGE_ELECTION_STATUS = ENDPOINT + "elections/changeStatus";

// Appointment configurations
export const APPOINTMENT_TIME_LIMIT = 15;
